import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 10l-2 9l-4 3l-3 -5l-3 -1l-2 -6l2 -5l3 -2l3 3l4 1l2 3","key":"svg-0"}],["path",{"d":"M3 10h18","key":"svg-1"}]]

/**
 * IconIceberg
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItaWNlYmVyZyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTkgMTBsLTIgOWwtNCAzbC0zIC01bC0zIC0xbC0yIC02bDIgLTVsMyAtMmwzIDNsNCAxbDIgMyIgLz4KICA8cGF0aCBkPSJNMyAxMGgxOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/iceberg
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconIceberg = createReactComponent('outline', 'iceberg', 'Iceberg', __iconNode);

export default IconIceberg;